import { FC } from "react";
import { useForm } from "react-hook-form";

// components
import { Button } from "@mui/material";
import Modal, { ModalProps } from "../../components/ModalDialogue";
import ModalHeader from "../../components/ModalDialogue/Header";
import ModalFooter from "../../components/ModalDialogue/Footer";
import ModalBody from "../../components/ModalDialogue/Body";
import UserForm from "./UserForm";

// types
import { UserFormData, UserOptions } from "./types";

export interface AddUserModalProps extends Omit<ModalProps, "children"> {
  options: UserOptions;
  onAdd: (User: UserFormData) => void;
}

const AddUserModal: FC<AddUserModalProps> = ({ options, onAdd, onClose, ...props }) => {
  const form = useForm<UserFormData>({
    mode: "onBlur",
    defaultValues: { displayName: "", username: "", role: "", siteIds: [] },
  });
  const { handleSubmit } = form;

  const handleClose = () => onClose?.({}, "backdropClick");

  const handleAdd = handleSubmit((data) => {
    onAdd(data);
    handleClose();
  });

  return (
    <Modal boxProps={{ height: 800 }} onClose={onClose} {...props}>
      <>
        <ModalHeader children="Add User" />

        <ModalBody>
          <UserForm form={form} options={options} />
        </ModalBody>

        <ModalFooter>
          <Button variant="text" color="secondary" children="Cancel" onClick={handleClose} />
          <Button variant="contained" sx={{ ml: 2 }} children="Add" onClick={handleAdd} />
        </ModalFooter>
      </>
    </Modal>
  );
};

export default AddUserModal;
